import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "confirmation_modal",
  class: "rounded",
  "data-testid": "test-confirmModal"
}
const _hoisted_2 = { class: "flex flex-col justify-center p-4" }
const _hoisted_3 = { class: "flex flex-col p-5" }
const _hoisted_4 = { class: "text-xl md:text-2xl text-center mb-5" }
const _hoisted_5 = { class: "flex justify-between" }

import { watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationDialog',
  props: {
  userId: {
    type: String,
    required: true,
  },
  customText: {
    type: String,
    required: true,
  },
  customCancel: {
    type: String,
    required: false,
    default: "Cancel",
  },
  customSubmit: {
    type: String,
    required: false,
    default: "Submit",
  },
  openDialog: {
    type: Boolean,
    required: true,
  },
},
  emits: ["submit"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

watch(
  () => props.openDialog,
  async (_) => {
    const dialog = document.getElementById("confirmation_modal");
    (dialog as HTMLDialogElement)?.showModal();
  }
);

const sendSubmit = () => {
  closeDialog();
  emit("submit", { id: props.userId });
};

const closeDialog = () => {
  const dialog = document.getElementById("confirmation_modal");
  (dialog as HTMLDialogElement)?.close();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dialog", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(__props.customText), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = () => sendSubmit()),
            class: "btn btn-outline btn-sm mr-2 bg-red"
          }, _toDisplayString(__props.customSubmit), 1),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = () => closeDialog()),
            class: "btn btn-info btn-sm mr-2"
          }, _toDisplayString(__props.customCancel), 1)
        ])
      ])
    ])
  ]))
}
}

})